export default __webpack_public_path__ + "static/media/three.e1628525.jpg";